import { memo } from "react";
import { FormattedMessage } from "react-intl";
import "./CalendarDisabledView.scss";
import Button, { BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import PropTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const CalendarDisabledView = ({ mainMessage, secondaryMessage, onDismiss }) => {
	return (
		<div className="calendar-disabled-view" data-testid="calendar-disabled-view">
			<div className="calendar-disabled-view__content">
				{mainMessage && (
					<Typography
						variant={TYPOGRAPHY_VARIANTS.XL}
						variantMD={TYPOGRAPHY_VARIANTS.LARGE}
						isBold
					>
						{mainMessage}
					</Typography>
				)}
				{secondaryMessage && (
					<div className="calendar-disabled-view__description">{secondaryMessage}</div>
				)}

				{onDismiss && (
					<div className="calendar-disabled-view__cta">
						<Button
							variant={BUTTON_VARIANTS.FILLED}
							onClick={onDismiss}
							label={
								<FormattedMessage id="sdp.calendar.unavailable.date.change.cta.label" />
							}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

CalendarDisabledView.propTypes = {
	onDismiss: PropTypes.func,
	mainMessage: PropTypes.string,
	secondaryMessage: PropTypes.string,
};

export default memo(CalendarDisabledView);
